<!-- prettier-ignore -->
<div>
  @if (iconPath) {
    <svg
      class="icon"
      [attr.viewBox]="viewBox"
      [attr.width]="width"
      [attr.height]="height"
      [attr.fill]="color"
      role="img"
      [attr.aria-label]="ariaLabel || name"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path [attr.d]="iconPath" />
    </svg>
  }
</div>
